module.exports = __webpack_public_path__ + "static/media/2.2eb6feab.jpg";